export default __webpack_public_path__ + "static/media/fastener-placement-rounded-rectangle-3-breaks.b263eaa1.webp";